import { FormattedMessage } from 'react-intl';
import { NavLink, Link } from 'react-router-dom';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import IframeResizer from 'iframe-resizer-react';

import { config } from '../../config';
import ServiceInfo from './ServiceInfo';
import { useAppSelector } from '../../configuration/setup/hooks';
import { getUserProfile } from '../../configuration/login/loginSlice';
import { OrderChat } from '@rio-cloud/rio-order-chat-component';
import { RioNotifications } from '@rio-cloud/rio-notifications-component';

const AppHeader = () => {
    const navItems = [
        {
            key: 'overview',
            route: (
                <NavLink to={'/overview'}>
                    <FormattedMessage id={'intl-msg:network.sublink.overview'} />
                </NavLink>
            ),
        },
    ];

    const environment = import.meta.env.DEV ? 'local' : 'production';
    const tenant = useAppSelector(getUserProfile)?.tenant || 'unknown';

    const chat = <OrderChat tenant={tenant} />;
    const serviceInfoItem = <ServiceInfo />;
    const userMenuItem = <DefaultUserMenu environment={environment} />;
    const notifications = <RioNotifications />;

    return (
        <ApplicationHeader
            label={<FormattedMessage id={'intl-msg:network.moduleName'} />}
            appNavigator={<IframeResizer className={'iFrameResizer'} src={config.backend.MENU_SERVICE} />}
            homeRoute={<Link to={config.homeRoute || ''} />}
            navItems={navItems}
            actionBarItems={[serviceInfoItem, chat, notifications, userMenuItem]}
        />
    );
};

export default AppHeader;
